/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AutomaticPauseTemplate } from '../../models/automatic-pause-template';
import { AutomaticPauseTemplateCreateRequest } from '../../models/automatic-pause-template-create-request';

export interface CreateAutomaticPauseTemplate$Params {
  'Active-Tenant-Identifier': string;
      body: AutomaticPauseTemplateCreateRequest
}

export function createAutomaticPauseTemplate(http: HttpClient, rootUrl: string, params: CreateAutomaticPauseTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<AutomaticPauseTemplate>> {
  const rb = new RequestBuilder(rootUrl, createAutomaticPauseTemplate.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AutomaticPauseTemplate>;
    })
  );
}

createAutomaticPauseTemplate.PATH = '/ordering/automatic-pause-templates';
